module.exports = __webpack_public_path__ + "img/banner-bg.65943959.png";